import Dialog from './Dialog';
import React from 'react';
import { WEBSITE_URL } from '../constants';

// What used to be the first-run intro/disclaimer, now reachable any time from
// Settings → About. Keeps the non-medical wording and the crisis line.
const About = ({ onClose }) => (
  <Dialog onClose={onClose} label="About TapTap" className="fixed inset-0 z-modal bg-black/80 backdrop-blur-md flex items-center justify-center p-4 pointer-events-auto">
    <div
      className="max-w-lg w-full bg-slate-900 border border-white/10 rounded-3xl p-6 shadow-2xl max-h-[85vh] overflow-y-auto overscroll-contain"
      style={{ WebkitOverflowScrolling: 'touch', touchAction: 'pan-y' }}
    >
      <h2 className="text-2xl font-bold mb-4 tracking-tight bg-gradient-to-r from-blue-400 via-indigo-300 to-purple-400 bg-clip-text text-transparent">
        About TapTap
      </h2>

      <div className="text-gray-300 leading-relaxed space-y-4">
        <p>
          TapTap is a wellness app for relaxation and focus. Tap the gently pulsating spheres
          from side to side, and the steady left–right rhythm becomes a calm anchor for your
          attention — like the breath in meditation — helping you slow down and feel more present.
        </p>
        <p className="text-sm opacity-80">
          It draws on two well-studied ideas: <strong className="text-white font-medium">mindfulness
          meditation</strong>, and rhythmic <strong className="text-white font-medium">bilateral
          (left–right) stimulation</strong> — approaches research has associated with lower stress
          and reduced bodily arousal.
        </p>
        <p className="text-sm opacity-80">
          TapTap is for wellness support only. It is not a medical device and does not diagnose or
          treat any condition, and is not a substitute for professional care.
        </p>
        <div className="text-sm space-y-2">
          <h3 className="text-white font-semibold">Motion and sensory settings</h3>
          <p>TapTap follows your device’s Reduce Motion preference to reduce decorative
            animations, such as pulsing labels and moving tutorial highlights. The orbs
            still appear and fade so you can follow the left–right rhythm.</p>
          <p>On iPhone, go to Settings → Accessibility → Motion → Reduce Motion.
            In TapTap’s Settings, you can also turn off Sound or Haptics, or switch off
            Show Progress to hide progress displays and achievement notifications.</p>
        </div>
        <p className="text-xs opacity-70">
          If you are in crisis or in danger, call <strong className="text-white">999</strong>, or
          Samaritans on <strong className="text-white">116&nbsp;123</strong> (free, 24/7).
        </p>
      </div>

      <a
        href={WEBSITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full mt-6 py-3 text-center text-indigo-200 font-semibold rounded-2xl border border-indigo-300/25 bg-indigo-400/10 hover:bg-indigo-400/20 transition-colors"
      >
        Visit taptap.org.uk
      </a>

      <button
        onClick={onClose}
        className="w-full mt-3 py-3 text-white font-bold rounded-2xl bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 transition-all transform active:scale-95 shadow-lg shadow-purple-500/25"
      >
        Close
      </button>
    </div>
  </Dialog>
);

export default About;
